import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-subscription-grid',
  templateUrl: './subscription-grid.component.html',
  styleUrls: ['./subscription-grid.component.css']
})
export class SubscriptionGridComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListIsActive: IsActiveItem[] = [];

    public grid?: GridOptions;

    public businessButtons: FormButton[] = [
        { id: 'erase', type: 'danger', icon: 'fa fa-solid fa-eraser', onClick: () => this.clear('businessco_no') }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(3207, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadIsActive(): Promise<void> {
        this.selectListIsActive = await this.datatask.Post(3252);
    }

    private async loadCompanies(): Promise<void> {
        this.selectListCompanies = await this.logistic.getCompanies('1');
    }

    private async retrieveNextCounterNumber() {
        const response = (await this.datatask.Post(678, { counter_id: 'subscription_keyno' }))[0];

        this.stateService?.go('subscription', { subscription_keyno: response?.nextnumber });
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_subscriptiongrid.grid')
                .setLoadDataFunction({
                    method: 3208,
                    parameters: this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'subscriptiongrid_new',
                    text: 'subscriptiongrid_new',
                    func: () => this.retrieveNextCounterNumber(),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private clear(id: string) {
        switch (id) {
            case 'businessco_no':
                if (!!this.setting) {
                    this.setting.businessco_no = '99999';

                    if (this.setting.businessco_no === '99999') this.loadGrid();
                }
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'businessco_no':
            case 'is_active':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadIsActive();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    argtype: string;
    argvalue: string;
    is_active: string;
}

interface IsActiveItem {
    is_active_id: string;
    is_active_name: string;
    orderby: number;
}
